export const prepareQueryParams = (queryParams: any) => {
  let query = "";
  if (queryParams.constructor === Object && Object.keys(queryParams)?.length) {
    query = "?";
    Object.keys(queryParams).forEach((key: any) => {
      if (
        Object.prototype.hasOwnProperty.call(queryParams, key) &&
        (queryParams[key] || typeof queryParams[key] === "boolean")
      ) {
        if (query === "?") {
          query += `${key}=${queryParams[key]}`;
        } else {
          query += `&${key}=${queryParams[key]}`;
        }
      }
    });
  }
  return query !== "?" ? query : "";
};
